/**
 * The unread-conversations count behind the "Support chat" nav badge.
 *
 * The key sits under `qk.chat`, so the realtime spine's `chat:message`
 * invalidation refreshes it the moment a customer writes; the 60 s interval is
 * only the fallback for a dropped socket. Errors (e.g. a backend that predates
 * the endpoint) simply mean no badge.
 */
import type { Accessor } from "solid-js";
import { useQuery } from "@tanstack/solid-query";

import { qk } from "~/core/query/client";
import { getUnreadCount } from "./api";

export function useChatUnreadBadge(): Accessor<number> {
  const unread = useQuery(() => ({
    queryKey: qk.chat.unread(),
    queryFn: getUnreadCount,
    refetchInterval: 60_000,
    retry: false,
    // A missing badge is not worth an error boundary.
    throwOnError: false,
  }));
  return () => (unread.isSuccess ? (unread.data?.rooms ?? 0) : 0);
}
